import { apiPlayerDetails } from "../../Redux/Types";
import { SignUpFormState } from "../../SignUp/Types";
import { PeerGamingApiSlice } from "../PeerGamingApiSlice";

export const userSlice = PeerGamingApiSlice.injectEndpoints({
	endpoints(builder) {
		return {
			login: builder.mutation<apiPlayerDetails, {username: string, password: string}>({
				query: (body) => ({
					url: `/Users/Login`,
					method: 'POST',
					body
				})
			}),

			createLogin: builder.mutation<apiPlayerDetails, SignUpFormState>({
				query: (body) => ({
					url: '/Users',
					method: 'POST',
					body
				})
			})

		}
	}
});

export const { useLoginMutation, useCreateLoginMutation } = userSlice;